<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
                                        <div class="page-body">
                                            <div class="col-md-12 col-xl-12">

                                                <!-- <div class="alert alert-info icons-alert" v-show="duplicate_detected.length > 0">
                                                    <button type="button btn-sm" class="close" data-dismiss="alert"
                                                        aria-label="Close">
                                                        <i class="icofont icofont-close-line-circled"></i>
                                                    </button>
                                                    <p>
                                                        This applicant has applied
                                                        <strong>
                                                            <span v-if="duplicate_detected.length > 1">
                                                                {{duplicate_detected.length}} times
                                                            </span>
                                                            <span v-else>
                                                                once
                                                            </span>
                                                        </strong>
                                                        in the past 6 months.
                                                    </p>
                                                </div> -->

                                                <div class="d-flex" v-if="$checkPerm('application.view_applicant_submissions')">
                                                    <button @click="handleSearch('sf')" type="button" class="btn btn-md btn-danger"
                                                        data-toggle="modal" data-target="#searchResult">
                                                        <i class="icofont icofont-search"></i>
                                                        Search Sundry Foods
                                                    </button>
                                                    <button @click="handleSearch('sm')" type="button" class=" btn btn-md btn-warning"
                                                        data-toggle="modal" data-target="#searchResult">
                                                        <i class="icofont icofont-search"></i>
                                                        Search Sundry Markets
                                                    </button>
                                                </div>

                                                <div class="general-controls mb-3">
                                                    <button v-if="$checkPerm('application.send_email')" class="btn btn-md btn-primary mt-2"
                                                        data-toggle="modal" data-target="#emailApplicant" title="Send this applicant an email"><i
                                                            class="icofont icofont-send-mail"></i>Send E-mail</button>
                                                    &nbsp;
                                                    <a v-bind:href="'/usersummary/' + applicant_id" class="btn btn-md btn-primary mt-2"
                                                        target="_blank"><i class="icofont icofont-list"></i>Full
                                                        Summary</a>

                                                    <!---&nbsp;-->
                                                    <!----<button v-if="applicant.stage > '1'" class="btn btn-md btn-danger mt-2"
                                                        v-on:click="reverseStage" title="Send the candidate one stage lower than current stage. E.g from Stage 3 to Stage 2"><i
                                                            class="icofont icofont-arrow-left"></i>Reverse Stage</button>-->

                                                </div>

                                                <div class="card summery-card">
                                                    <ul class="nav nav-tabs md-tabs" role="tablist">
                                                        <li class="nav-item">
                                                            <a class="nav-link active" data-toggle="tab" href="#stage1"
                                                                role="tab" aria-expanded="false">Stage 1</a>
                                                            <div class="slide"></div>
                                                        </li>
                                                         <li v-if="applicant_stage.stage > 1" class="nav-item">
                                                            <a class="nav-link" data-toggle="tab" href="#stage2" role="tab"
                                                                aria-expanded="false">Stage 2</a>
                                                            <div class="slide"></div>
                                                        </li>
                                                        <li v-if="applicant_stage.stage > 2" class="nav-item">
                                                            <a class="nav-link" data-toggle="tab" href="#stage3" role="tab"
                                                                aria-expanded="false">Stage 3</a>
                                                            <div class="slide"></div>
                                                        </li>
                                                       
                                                    </ul>
                                                    <div class="tab-content card-block">

                                                        <div class="tab-pane active" id="stage1" role="tabpanel"
                                                            aria-expanded="false">
                                                            <Stage1 />
                                                        </div>

                                                        <div class="tab-pane" id="stage2" role="tabpanel" aria-expanded="false">
                                                            <Stage2 />
                                                        </div>

                                                        <div class="tab-pane" id="stage3" role="tabpanel" aria-expanded="false">
                                                            <Stage3 />
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div id="emailApplicant" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Email {{applicant.firstname + " " + applicant.lastname}}.</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form v-on:submit.prevent="emailApplicant">
                            <div class="form-group">
                                <label>Recipient:</label>
                                <input type="text" name="recipient" class="form-control" readonly="readonly" required="required"
                                    v-model="email.recipient_mail[0]" />
                            </div>
                            <div class="form-group">
                                <label>Title:</label>
                                <input type="text" name="title" class="form-control" required="required" v-model="email.email_title" />
                            </div>
                            <div class="form-group">
                                <summernote height="300" :model.sync="email.email_body"></summernote>
                            </div>
                            <div class="form-group">
                                <input type="submit" name="submit" class="btn btn-primary" value="Send Email" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div id="star" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 v-if="applicant.is_starred" class="modal-title">Unarchive {{applicant.firstname + " " + applicant.lastname}}</h4>
                        <h4 v-else class="modal-title">Archive {{applicant.firstname + " " + applicant.lastname}} for later.</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="starApplicant">
                            <div v-if="applicant.is_starred != 1" class="form-group">
                                <label>Reason:</label>
                                <textarea class="form-control" placeholder="Reason" maxlength="500" v-model="star_application.reason"></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-success">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- searchresult -->
        <div id="searchResult" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Search Result.</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>First name</th>
                                    <th>Last name</th>
                                    <th>Email</th>
                                    <th>Job</th>
                                    <th>Experience</th>
                                    <th>Stage</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row,index) in result">
                                    <td>{{row.firstname}}</td>
                                    <td>{{row.lastname}}</td>
                                    <td>{{row.emailaddress}}</td>
                                    <td>{{row.joblistings.jobrole.name}}</td>
                                    <td>{{row.years_of_experience}}</td>
                                    <td>{{row.process_details}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<style scoped>
    tr td:nth-child(1) {
        font-weight: bold;
    }

    h5 {
        font-weight: bold;
    }

    .image-holder {
        width: 120px;
        height: 120px;
        margin: 0 auto;
    }

    .image-holder img {
        width: 100%;
        /*height: 100%;*/
    }

    .contact-icon {
        margin-top: 50px !important;
        text-align: center;
    }

    .p-l-0 {
        padding-left: 0px !important;
    }

    .feed-card {
        cursor: pointer;
    }

    button.close {
        margin-top: 0px !important;
    }

    .icons-alert:before {
        top: inherit !important;
    }
</style>
<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'
    import summernote from '../components/Summernote.vue'
    import Stage1 from '../components/ApplicantStages/Stage1.vue'
    import Stage2 from '../components/ApplicantStages/Stage2.vue'
    import Stage3 from '../components/ApplicantStages/Stage3.vue'

    export default {
        name: 'Application',

        data() {
            return {
                applicant: {
                    referrer_name: '',
                    documents: [
                        {
                            link: ""
                        }
                    ],
                    joblistings: {
                        id: "",
                        jobrole: {
                            name: ""
                        }
                    }
                },
                opening: [],
                applicant_id: '',
                opening_id: '',
                processes: [],
                applicant_stage: '',
                applicant_processes: [],
                email: {
                    email_title: "",
                    email_body: "",
                    recipient_mail: []
                },
                duplicate_detected: [],

                stage_processes: {
                    process_id: [],
                    applicant_id: ''
                },

                star_application: {
                    applicant_id: this.$route.params.applicant_id,
                    reason: '',
                    date_starred: ''
                },
                result: []
            }
        },

        components: {
            navbar1,
            navbar2,
            summernote,
            Stage1,
            Stage2,
            Stage3
        },

        mounted() {
            this.init()
        },

        methods: {

            init: function () {
                this.applicant_id = this.$route.params.applicant_id
                this.opening_id = this.$route.params.id

                this.markAsSeen()

                this.getOpening(this.$route.params.id)

                this.getProcesses()

                this.duplicateDetection()
            },

            getOpening(id) {

                var get_openings_request = {
                    what: 'GetApplicant',
                    id: this.applicant_id
                    
                }

                this.$socket.makeGetRequest(get_openings_request)
                    .then((response) => {
                        if (response.type == 'GetApplicant') {
                            // this.opening = response.data
                            console.log(this.opening)
                            this.getApplicantInfoFromOpening(response.data)
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                    })
            },

            getApplicantInfoFromOpening(applicant) {
                // var applicant_index = this.getApplicantIndex(applicant_id)
                // this.applicant = this.opening[applicant_index]
                this.applicant = applicant

                //Get process for stage 2 (If applicant in Stage 2)
                this.getApplicantProcessByStage("2")

                //Add applicant's email to "email" data
                this.email.recipient_mail.push(this.applicant.emailaddress)

                console.log(this.applicant)
            },

            getApplicantIndex(applicant_id) {

                var index = 0
                var opening = this.opening

                for (var i = 0; i < opening.length; i++) {
                    if (opening[i].id == applicant_id) {
                        index = i
                        break
                    }
                }

                return index
            },

            getProcesses() {
                var stages = {
                    what: 'GetProcesses'
                }

                this.$socket.makeGetRequest(stages)
                    .then((response) => {
                        if (response.type == 'GetProcesses') {
                            this.processes = response.data
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            getApplicantProcessByStage(stage) {

                let applicant_stages = this.applicant.applicant_stages
                let stages_count = applicant_stages.length
                var p = {}

                for (var i = 0; i < stages_count; i++) {
                    p = {
                        stage: applicant_stages[i].stage_id,
                        process: applicant_stages[i].process_details
                    }
                }

                this.applicant_processes.push(p)
                this.applicant_stage = p

                console.log(this.applicant_stage)

            },

            starApplicant() {

                var d = new Date()
                var mm = (d.getDate().toString().length < 2) ? '0' + d.getDate().toString() : d.getDate()
                var dd = (d.getMonth().toString().length < 2) ? '0' + d.getMonth().toString() : d.getMonth()
                var yyyy = d.getFullYear()

                var full_date = yyyy + '-' + mm + '-' + dd

                this.star_application.date_starred = full_date
                this.star_application.starred_by = this.$store.getters.user_data.data.id

                let api = null;
                let star = null;

                if(this.applicant.is_starred == 0){
                    star = {
                        what: 'StarApplication',
                        data: this.star_application
                    }
                    api = this.$socket.makePostRequest(star)
                    
                } else {
                    star = {
                        what: 'UnStarApplication',
                        id : this.applicant.id
                    }
                    api = this.$socket.makeGetRequest(star)
                    
                }

                // console.log(api)


                

                api
                    .then((response) => {
                        if (response.status == "true") {
                            if(response.type == 'StarApplication'){
                                window.alert("Applicant archived.")
                            } else {
                                window.alert("Applicant unarchived.")
                            }

                            setTimeout(() => {
                                window.location.reload()
                            }, 1000)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            deleteApplicant() {
                var id = this.applicant_id

                var c = confirm("Delete application?")

                if (c) {

                    var del_applicant = {
                        what: 'DeleteApplicant',
                        id: id
                    }

                    this.$socket.makeGetRequest(del_applicant)
                        .then((response) => {
                            if (response.type == 'DeleteApplicant' && response.status) {
                                //this.processes = response.data
                                window.alert('Applicant deleted!')

                                setTimeout(() => {
                                    window.location.href = "../"
                                }, 2000)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            },

            emailApplicant() {

                var send_email = {
                    what: 'SendEmail',
                    data: this.email
                }

                this.$socket.makePostRequest(send_email)
                    .then((response) => {
                        if (response.type == "SendEmail") {
                            this.$swal.fire("Success", "Email sent to recipient.", 'success')

                            setTimeout(() => {
                                window.location.reload()
                            }, 1000)
                        }
                    })
                    .catch((error) => {
                        console.log(error)

                    })
            },


            /* practicalEvaluation: function () {
                 let id = this.applicant.id
 
                 let p_eval = {
                     what: "PracticalEvaluation",
                     data: {
                         applicant_id: id
                     }
                 }
 
                 let c = confirm("Route candidate to practical evaluation?")
 
                 if (c) {
                     this.$socket.makePostRequest(p_eval)
                         .then((response) => {
                             if (response.type == "PracticalEvaluation") {
                                 this.$swal.fire('Success', response.data.message, 'success')
                             }
                         })
                         .catch((error) => {
                             console.log(error)
                             this.$swal.fire('Error', error.message, 'error')
                         })
                 }
             },*/

            duplicateDetection: function () {

                let request = {
                    what: 'DuplicateDetection',
                    params: {
                        applicant_id: this.applicant_id
                    }
                }

                this.$socket.makeGetRequest(request)
                    .then((response) => {
                        if (response.type == "DuplicateDetection") {
                            this.duplicate_detected = response.data
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            reverseStage: function () {

                let request = {
                    what: 'ReverseApplicantStage',
                    params: {
                        applicant_id: this.applicant_id
                    }
                }

                let c = confirm("This action will reverse the applicant's current stage, do you wish to proceed?")

                if (c) {
                    this.$socket.makeGetRequest(request)
                        .then((response) => {
                            if (response.type == "ReverseApplicantStage") {
                                this.$swal.fire('Success', response.data.message, 'success')
                            }

                            setTimeout(() => {
                                window.location.reload()
                            }, 2000)
                        })
                        .catch((error) => {
                            this.$swal.fire('Error', error.data.message, 'error')
                            console.log(error)
                        })
                }
            },

            markAsSeen: function () {
                let id = this.applicant_id

                let p_eval = {
                    what: "MarkViewed",
                    data: {
                        applicant_id: id
                    }
                }

                this.$socket.makePostRequest(p_eval)
                    .then((response) => {
                        if (response.type == "MarkViewed") {
                            //this.$swal.fire('Success', response.data.message, 'success')
                            console.log('Applicant marked as seen.')
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        this.$swal.fire('Error', error.message, 'error')
                    })
            },
            handleSearch(company) {
                console.log(this.applicant);
                let url;
                if (company == 'sf') {
                    url = `https://sundryfoods.website/api/validatecandidate?firstname=${this.applicant.firstname}&lastname=${this.applicant.lastname}&emailaddress=${this.applicant.emailaddress}&company_id=${this.applicant.company_id}`
                }
                else {
                    url = `https://sundryfoods.website/api/validatecandidate?firstname=${this.applicant.firstname}&lastname=${this.applicant.lastname}&emailaddress=${this.applicant.emailaddress}&company_id=${this.applicant.company_id}`
                }

                fetch(url, {
                    method: "get"
                })

                    .then(response => response.json())
                    .then(data => this.result = data.message);
            }

        },

        computed: {

        }
    }
</script>